/**
 * @packageDocumentation
 * Declares types and helpers for the in-game settings menu, including toggle wiring and persisted preferences.
 */
/** 
 * Class representing user options and settings menu
 * @extends PIXI.Container
 */
import * as PIXI from "pixi.js"; 
import { Assets } from 'pixi.js'; 
import { gsap } from "gsap/gsap-core";
import { brightnessFilter, font_main } from "./global";
import { SoundManager } from "./sounds";
import { EnumEventBus, EventBus } from "../EventBus";
import addInteraction from "../lib/addButtonInteraction";


export class UserOptions extends PIXI.Container{
    /** Container for all settings menu elements */
    public settingsContainer!:PIXI.Container;
    /** Container that controls settings menu scaling */
    private MuteAllMusicController!: PIXI.AnimatedSprite;
    private BgMusicController!: PIXI.AnimatedSprite;
    /**
     * Creates an instance of UserOptions
     * Initializes the settings menu and all its components
     */
    constructor(private app_width: number, private app_height: number){
        super();

        this.createSettingsContainer();
        this.createMuteBgMusic();
        this.createMuteAllMusic();
        this.creategameInfo();
        this.createClosebtn();
    }
    show() {
        this.checkSettings();
        gsap.killTweensOf(this.settingsContainer)
        gsap.fromTo(this.settingsContainer, { pixi: { scale: 0 } }, { pixi: { scale:0.9 }, ease: "elastic.out(1,0.5)" })
        this.settingsContainer.visible = true
    }
    /**
     * Creates the main container for the settings menu
     * Initializes containers and background
     */
    checkSettings() {
        const bgSoundStatus = SoundManager.getBgSound();
        const gameSoundStatus = SoundManager.getGameSound();

        this.BgMusicController.gotoAndStop(bgSoundStatus == "true" ? 0 : 1);
        this.MuteAllMusicController.gotoAndStop(gameSoundStatus == "true" ? 0 : 1);
    }
    createSettingsContainer(){
        this.settingsContainer = new PIXI.Container();
        this.settingsContainer.visible = false;
        let settingsBg = new PIXI.Sprite(Assets.get("popup"));
        settingsBg.anchor.set(0.5);
        settingsBg.scale.set(0.5);
        this.settingsContainer.addChild(settingsBg);
        this.addChild(this.settingsContainer)
    }

    /**
     * Creates the game rules button and info page functionality
     */
    creategameInfo(){ 
        let GameRulesBtn = new PIXI.Sprite(Assets.get("Plain_btn")) ;
        GameRulesBtn.anchor.set(0.5)
        GameRulesBtn.y = -this.settingsContainer.children[0].height/4
       let GameRulesBtnText = new PIXI.Text({text:"GAME RULES",style:{
         fontFamily: font_main, 
         stroke:{
             color:"black",
             width:1,
             join:"round"

         },
         align:"center",
         fill: 'yellow', 
         fontSize: 30,
         fontWeight: 'lighter',
         }})
         GameRulesBtnText.anchor.set(0.5)
         GameRulesBtn.addChild(GameRulesBtnText)
         GameRulesBtn.interactive = true
         GameRulesBtn.cursor = "pointer"
         GameRulesBtn.on("pointerover",()=>{
             GameRulesBtn.filters = [brightnessFilter]
         })
         GameRulesBtn.on("pointerout",()=>{
             GameRulesBtn.filters = []
         })
         GameRulesBtn.on("pointertap",()=>{
            SoundManager.Btnclick_1SndPlay();
            document.getElementById('info-page')!.style.display = 'block'; 
         })
        // this.settingsContainer.addChild(GameRulesBtn)

        const closeBtn = document.getElementById('info-close')!;
        closeBtn.addEventListener('click', () => {
          document.getElementById('info-page')!.style.display = 'none';
        }); 
    }

    /**
     * Creates the background music mute toggle button
     */
    createMuteBgMusic(){ 
        let BgMusicframes:PIXI.Texture[] = [Assets.get("fastplay_btn_without_clk"),Assets.get("fastplay_btn_with_clk")]
        this.BgMusicController = new PIXI.AnimatedSprite(BgMusicframes) ;
        this.BgMusicController.anchor.set(0.5)
        this.BgMusicController.y = -50
       let BgMusicControllerText = new PIXI.Text({text:"MUTE BG MUSIC",style:{
         fontFamily: font_main, 
         stroke:{
             color:"black",
             width:2,
             join:"round"

         },
         align:"center",
         fill: 'white', 
         fontSize: 30,
         fontWeight: 'lighter',
         }})
         BgMusicControllerText.anchor.set(0.5);
         BgMusicControllerText.x = -20;
         this.BgMusicController.addChild(BgMusicControllerText)
         this.BgMusicController.gotoAndStop(0);
         this.BgMusicController.interactive = true
         this.BgMusicController.cursor = "pointer"
         this.BgMusicController.on("pointerover",()=>{
             this.BgMusicController.filters = [brightnessFilter]
         })
         this.BgMusicController.on("pointerout",()=>{
             this.BgMusicController.filters = []
         })
         this.BgMusicController.on("pointertap",()=>{
            SoundManager.Btnclick_1SndPlay();

             if(this.BgMusicController.currentFrame==0){
                 this.BgMusicController.gotoAndStop(1)
                 SoundManager.MuteBgMusicFun();
                SoundManager.setBgSound(false);
             }else{
                this.BgMusicController.gotoAndStop(0)
                SoundManager.PlayBgMusicFun()
                SoundManager.setBgSound(true);
             }

         })
        this.settingsContainer.addChild(this.BgMusicController)

    }

    /**
     * Creates the all sound mute toggle button
     */
    createMuteAllMusic(){ 
        let MuteAllMusicframes:PIXI.Texture[] = [Assets.get("fastplay_btn_without_clk"),Assets.get("fastplay_btn_with_clk")]
        this.MuteAllMusicController = new PIXI.AnimatedSprite(MuteAllMusicframes) ;
        this.MuteAllMusicController.anchor.set(0.5)
        this.MuteAllMusicController.y = this.settingsContainer.children[0].height/4-35
       let MuteAllMusicControllerText = new PIXI.Text({text:"MUTE ALL MUSIC",style:{
         fontFamily: font_main, 
         stroke:{
             color:"black",
             width:2,
             join:"round"

         },
         align:"center",
         fill: 'white', 
         fontSize: 30,
         fontWeight: 'lighter',
         }})
         MuteAllMusicControllerText.anchor.set(0.5)
         //MuteAllMusicControllerText.x=-5
         MuteAllMusicControllerText.x = -20;

         this.MuteAllMusicController.addChild(MuteAllMusicControllerText)
         this.MuteAllMusicController.gotoAndStop(0);
         this.MuteAllMusicController.interactive = true
         this.MuteAllMusicController.cursor = "pointer"
         this.MuteAllMusicController.on("pointerover",()=>{
         this.MuteAllMusicController.filters = [brightnessFilter]
         })
         this.MuteAllMusicController.on("pointerout",()=>{
             this.MuteAllMusicController.filters = []
         })
         this.MuteAllMusicController.on("pointertap",()=>{
            SoundManager.Btnclick_1SndPlay();

             if(this.MuteAllMusicController.currentFrame==0){
                 this.MuteAllMusicController.gotoAndStop(1)
                 
                SoundManager.MuteGameSoundFun();
                SoundManager.setGameSound(false);
             }else{
                 this.MuteAllMusicController.gotoAndStop(0)
                 SoundManager.PlayGameSoundFun()
                SoundManager.setGameSound(true);
             }
         })
        this.settingsContainer.addChild(this.MuteAllMusicController)

    }

    /**
     * Creates the close button for the settings menu
     */
    createClosebtn(){
        const closeBtnCon = new PIXI.Container();
        closeBtnCon.scale.set(.6);

        let closebtn = new PIXI.Sprite(Assets.get("close_btn"));
        closebtn.anchor.set(0.5)
        closeBtnCon.addChild(closebtn);

         const onHandleTapFunc = ()=>{
            SoundManager.Btnclick_1SndPlay(); 
                gsap.killTweensOf(this.settingsContainer) 
                gsap.fromTo(this.settingsContainer, { pixi: { scale: 0.9 } }, { pixi: { scale: 0 }, ease: "elastic.in(1,0.5)", onComplete: ()=>{
                EventBus.emit(EnumEventBus.setSettingsPopup, false);
                }})
        };
         addInteraction(closeBtnCon, onHandleTapFunc, true);
   

         closeBtnCon.x = this.settingsContainer.children[0].width/2-closeBtnCon.width/3-5
         closeBtnCon.y = -this.settingsContainer.children[0].height/2+closeBtnCon.height/3

         
        this.settingsContainer.addChild(closeBtnCon);
    }
    landscapeAdjust() {
        this.scale.set(1);
        this.settingsContainer.x = this.app_width / 2;
        this.settingsContainer.y = this.app_height / 2;
    }
    portraitAdjust() {
        this.scale.set(1.5);
        this.settingsContainer.x = this.app_width / 3;
        this.settingsContainer.y = this.app_height / 3;
    }
}
    
